export default "__VITE_ASSET__B5hd7nbo__"